import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  ErrorModal,
  GeneralModal,
  HeaderWithButtons,
  InfoBox,
  InfoLine,
  RemoveVerticalModal,
} from "../components-molecules";
import {
  getVerticalDetailsSymbols,
  removeVerticalDetails,
} from "../redux/actions/getVerticalDetails";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import { Categories } from "../components-organisms";
import CssBaseline from "@material-ui/core/CssBaseline";
import { HttpRegularPut } from "../service";
import { roleName } from "../utils/roles";
import { theme } from "../constants/theme";
import { usePrevious } from "../utils";
//import { getCategoriesSymbolsWithParams } from "../redux/actions/getCategories";
import trashIcon from "../assets/icons/trash-icon.svg";
import { CircularProggressIndicator } from "../components-atoms";
import { buttonHoverAndActive } from "../utils/styles/buttonStyles";
import { useTranslation } from 'react-i18next';

// import { setError } from "../redux/actions/error";

export const VerticalDetails = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  //const [logo, setLogo] = useState<any>();
  let { id }: { id: string } = useParams();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [editType, setEditType] = useState("");
  const [, setDataDetails] = useState<any>();
  const [removeModal, setRemoveModal] = useState(false);
  const [removeConfirm, setRemoveConfirm] = useState(false);
  const categoryData = useSelector(
    (state: any) => state.CategorySymbolsReducer.data
  );
  useEffect(() => {
    roleName() === "Admin" && dispatch(getVerticalDetailsSymbols(id));
    //dispatch(getCategoriesSymbolsWithParams(null, "Asc", { Verticals: [id] }));
  }, []); // eslint-disable-line
  const data = useSelector(
    (state: any) => state.VerticalDetailsSymbolsReducer.data
  );
  const previousData: any = usePrevious(data);
  const loading = useSelector(
    (state: any) => state.VerticalDetailsSymbolsReducer.loading
  );
  useEffect(() => {
    if (previousData && previousData.Id !== data.Id) {
      setDataDetails(data);
    }
  }, [previousData]); // eslint-disable-line

  const handleSubmit = () => {
    switch (editType) {
      case "Name":
        dispatch(handleSubmitBasicInfo("Name"));
        break;
      case "Description":
        dispatch(handleSubmitBasicInfo("Description"));
        break;
      default: {
        setEditModalOpen(false);
      }
    }
    //dispatch(getAccountDetails());
    setEditModalOpen(false);
  };

  const handleSubmitBasicInfo = (infoType: string) => {
    const body = {
      Name: data?.Name,
      Description: data?.Description,
    };
    if (infoType === "Name") {
      body.Name = name;
      setName("");
    } else if (infoType === "Description") {
      body.Description = description;
      setDescription("");
    } else {
    }
    return (disp: any) => {
      const fData = new FormData();
      fData.append(
        "json",
        JSON.stringify({
          Name: body.Name,
          Description: body.Description,
        })
      );

      HttpRegularPut("/upc/vertical/" + id, fData, {
        dispatch: disp,
        actionSuccess: () => getVerticalDetailsSymbols(id),
        // actionFailure: () => setError("Could not update!"),
      });
    };
  };

  /* const handleSubmitImage = (image: any) => {
    const fData = new FormData();
    fData.append("file", image);
    fData.append(
      "json",
      JSON.stringify({
        Name: data?.Name,
        Description: data?.Description,
        ImageChanged: true,
      })
    );
    return (dispatch: any) =>
      HttpRegularPut("/upc/vertical/" + id, fData, {
        dispatch: dispatch,
        actionSuccess: () => getVerticalDetailsSymbols(id),
        // actionFailure: () => setError("Could not update!"),
      });
  };
 */
  return (
    <Box className={classes.container}>
      {loading ? (
        <CircularProggressIndicator />
      ) : (
        <>
          <CssBaseline />
          <Container className={classes.root}>
            <HeaderWithButtons
              handleBack={() => history.goBack()}
              title={data?.Name ?? ""}
              smallText="Vertical"
            >
              <HeaderWithButtons.ButtonArea>
                <Button
                  onClick={() => {
                    if (categoryData.length === 0) {
                      setRemoveConfirm(true);
                    } else {
                      setRemoveModal(true);
                    }
                  }}
                  className={classes.removeButton}
                >
                  <img
                    src={trashIcon}
                    className={classes.buttonIcon}
                    alt="print icon"
                  />
                  <Typography variant="button" component="p" color="primary">
                    Remove
                  </Typography>
                </Button>
              </HeaderWithButtons.ButtonArea>
            </HeaderWithButtons>
            {/** alse || shopDetailsLoading || data.length === 0 ? */}

            <>
              <Container className={classes.detailsContainer}>
                <InfoBox title={t('admin.basicInformation')}>
                  <Grid item xs={12} className={classes.mt12b9}>
                    <Typography
                      variant="body2"
                      component="span"
                      color="textSecondary"
                    >
{t('admin.thisInformationWillBeVisible')}
                    </Typography>
                  </Grid>

                  <InfoLine
name={t('admin.verticalName')}
                    value={data?.Name ? data.Name : t('admin.pleaseSet')}
                    onClick={() => {
                      setEditType("Name");
                      setName(data?.Name ?? "");
                      setModalTitle("Vertical Name");
                      setEditModalOpen(true);
                    }}
                  >
                    <InfoLine.ArrowArea></InfoLine.ArrowArea>
                  </InfoLine>
                </InfoBox>
                <Categories Vertical={data} isUnderPage />
                <GeneralModal
                  visible={editModalOpen}
                  title={modalTitle}
                  description=""
                  onClose={setEditModalOpen}
                >
                  <GeneralModal.ContentArea>
                    {editType === "Name" ? (
                      <TextField
                        placeholder="Vertical Name"
                        value={name}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="Name"
                        label="Name"
                        name="Name"
                        onChange={(e) => setName(e.target.value)}
                        autoFocus
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                    ) : editType === "Description" ? (
                      <TextField
                        placeholder="Description"
                        value={description}
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="Description"
                        label="Description"
                        name="Description"
                        onChange={(e) => setDescription(e.target.value)}
                        autoFocus
                        InputProps={{
                          classes: {
                            root: classes.cssOutlinedInput,
                            focused: classes.cssFocused,
                            notchedOutline: classes.notchedOutline,
                          },
                        }}
                      />
                    ) : (
                      <></>
                    )}
                  </GeneralModal.ContentArea>
                  <GeneralModal.ButtonArea>
                    <Button
                      onClick={() => setEditModalOpen(false)}
                      className={classes.cancelButton}
                    >
                      <Typography
                        variant="button"
                        component="p"
                        color="primary"
                      >
                        Cancel
                      </Typography>
                    </Button>
                    <Button
                      onClick={handleSubmit}
                      className={classes.submitButton}
                    >
                      <Typography
                        variant="button"
                        component="p"
                        color="inherit"
                      >
                        Submit
                      </Typography>
                    </Button>
                  </GeneralModal.ButtonArea>
                </GeneralModal>
                <ErrorModal
                  errorBody="Please reassign all categories to another vertical before removing the vertical. Once all categories are reassigned you will be able to remove the vertical."
                  title="Remove vertical"
                  visible={removeModal}
                  onClose={() => setRemoveModal(false)}
                />
                <RemoveVerticalModal
                  onClose={() => setRemoveConfirm(false)}
                  open={removeConfirm}
                  onDelete={() =>
                    dispatch(
                      removeVerticalDetails(id, null, () => {
                        history.push("/admin/upceditor");
                      })
                    )
                  }
                />
              </Container>
            </>
          </Container>{" "}
        </>
      )}
    </Box>
  );
};
const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  imageList: {
    display: "flex",
    flexDirection: "row",
    marginTop: 15,
    paddingLeft: 0,
  },
  images: {
    width: 200,
    height: 150,
    marginRight: 10,
  },
  submitButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.secondary.main,
    marginRight: "8px",
  },
  removeButton: {
    borderRadius: "8px",
    padding: "6px 16px 6px 12px",
    ...buttonHoverAndActive
  },
  buttonIcon: {
    width: "18px",
    height: "18px",
    marginRight: 8,
  },
  cssOutlinedInput: {
    display: "flex",
    "&$cssFocused $notchedOutline": {
      border: `1px solid ${theme.palette.primary.main}`,

    },
  },

  cssFocused: {},

  notchedOutline: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
  printButtonText: {
    textTransform: "none",
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  detailsContainer: {
    marginTop: "24px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  printableSection: {
    display: "none",
  },
  infoTextContainer: {
    alignItems: "center",
    paddingTop: 15,
    paddingBottom: 15,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  },
  uMb8: {
    marginBottom: 8,
  },
  mt12b9: {
    marginTop: 12,
    marginBottom: 9,
  },
});
